/* Made in England Research: colour helpers.
   1. Marks the topic label on each card so research-colour.css can give it its topic colour.
   2. Draws a bar behind each percentage in simple Answer / % results tables, and marks one answer in gold:
      on a finding with a headline percentage, the answer that matches it; on pages without one (such as the
      full report), the largest answer in each table, ignoring "Not sure", "Don't know" and the like.
      A United Kingdom or England row is marked so its bar shows in solid green.
   3. Keeps chart captions in step with the colours: the halfway tick on the Who Feeds Britain card is gold. */
(function () {
  var SKIP = /^(not sure|don.?t know|none|no preference|prefer not|nothing in particular)/i;
  var HOME = /^(united kingdom|uk|england)$/i;
  var head = '', headDone = false;

  function topics() {
    document.querySelectorAll('.rs-lb > span:nth-child(2), .rs-mt > span:nth-child(2)').forEach(function (s) {
      if (!s.hasAttribute('data-tc') && !s.classList.contains('rs-tag')) s.setAttribute('data-tc', s.textContent.trim());
    });
  }

  function num(c) {
    var v = parseFloat(c.style.getPropertyValue('--v'));
    return isNaN(v) ? parseFloat(c.textContent) : v;
  }

  function single(t) {
    return [].filter.call(t.querySelectorAll('tbody tr'), function (r) { return r.querySelectorAll('td.rs-bc').length === 1; });
  }

  function mark(t) {
    var rows = single(t);
    rows.forEach(function (r) { if (HOME.test((r.cells[0] ? r.cells[0].textContent : '').trim())) r.classList.add('rs-home'); });
    if (t.querySelector('tr.rs-top-a')) return;
    if (head) {
      if (headDone) return;
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].querySelector('td.rs-bc').textContent.trim() === head) { rows[i].classList.add('rs-top-a'); headDone = true; return; }
      }
      return;
    }
    var best = null, bv = -1;
    rows.forEach(function (r) {
      if (SKIP.test((r.cells[0] ? r.cells[0].textContent : '').trim())) return;
      var v = num(r.querySelector('td.rs-bc'));
      if (!isNaN(v) && v > bv) { bv = v; best = r; }
    });
    if (best) best.classList.add('rs-top-a');
  }

  function tables() {
    var b = document.querySelector('.rs-art-side .rs-st b');
    var t0 = b ? b.textContent.trim() : '';
    if (/^\d+(\.\d+)?%$/.test(t0)) head = t0;
    document.querySelectorAll('.rs-prose table').forEach(function (t) {
      if (t.classList.contains('rs-bt')) { if (t.classList.contains('rs-bt-1')) mark(t); return; }
      var hd = t.tHead && t.tHead.rows[0];
      var body = t.tBodies[0];
      if (!hd || !body || hd.cells.length !== 2 || hd.cells[1].textContent.trim() !== '%') return;
      var rows = [].slice.call(body.rows);
      if (!rows.length) return;
      var ok = rows.every(function (r) { return r.cells.length === 2 && /^\d+(\.\d+)?%$/.test(r.cells[1].textContent.trim()); });
      if (!ok) return;
      t.classList.add('rs-bt', 'rs-bt-1');
      rows.forEach(function (r) {
        var c = r.cells[1];
        c.classList.add('rs-bc');
        c.style.setProperty('--v', parseFloat(c.textContent));
      });
      mark(t);
    });
  }

  function captions() {
    document.querySelectorAll('.rs-vis p').forEach(function (p) {
      if (p.textContent.indexOf('white tick') >= 0) p.textContent = p.textContent.replace('white tick', 'gold tick');
    });
  }

  function run() { topics(); tables(); captions(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
